<template>
	<div class="footer_box">
		
		<div class="layout">
			<div class="footer_qr_code">
				<ul>
					<li><img src="@/assets/img/footer/wx_mini_program.jpg" alt="" srcset="" /><p>微信小程序</p></li>
					<li><img src="@/assets/img/footer/wx_ems_cnpl.jpg" alt="" srcset="" /><p>微信公众号</p></li><!-- 
					<li><img src="@/assets/img/footer/wx_enterprise_wechat.jpg" alt="" srcset="" /><p>本地求职群</p></li> -->
				</ul>
			</div>
		    <div class="footer_box_right">
				<!-- <div class="footer_box_link">
				  <div class="footer_box_item" v-for="(item,index) in linkList " :key="index" @click="tohelp(item)">{{
					  item.name
					}}
				  </div>
				</div> -->
				<div class="footer_box_titl" style="margin-top: 14px">您对西北人才网有任何建议或者意见请联系我们：0931-5180337</div>
				<div class="footer_box_titl" style="margin-bottom: 13px">未经西北人才网同意，不得转载本网站所有招聘信息及作品，版权归西北人才网所有</div>
				<div class="footer_box_li">
					<a href="https://www.xbrc.com.cn/oss/xbrcw/gg-html/2025-12-31/7729a3fd-a4a7-4daf-aaea-0881c993e30e/index.html" target="_blank" style="padding-right:10px;color: inherit; text-decoration: none;">
					  互联网公约
					</a> |
					<span @click="$router.push('/agreement?3')">法律申明</span>|
					<span @click="$router.push('/agreement?4')">隐私保护</span>|
					<span @click="userClick">用户协议</span>
				</div>
				<div class="footer_box_bq">
					© 1999-2057 西北人才网版权所有&nbsp;&nbsp;&nbsp;
					<a href="https://beian.miit.gov.cn/" target="_blank">陇ICP备2021001325号-1</a>&nbsp;&nbsp;&nbsp; 
					<img src="@/assets/img/footer/logo_gongan.png">&nbsp;
					<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62010002000061">甘公网安备 62010002000061号</a>
				</div>
		    </div>			
		</div>		
	</div>
</template>

<script>
import {friendlinklist} from "../api/home";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      // 判断路由改变footer背景色
      routePath: false,
      routeList: [
        "/headfairmain/talentAssessment",
        "/headfairmain/baicaiHeadhunting",
        "/headfairmain/RPO",
        "/headfairmain/reference",
      ],
      linkList: [
        {url: "/helpCenter?index=3", name: "西北人才网简介"},
        {url: "/helpCenter?index=3", name: "加入网站"},
        {url: "/helpCenter?index=3", name: "联系方式"},
        {url: "/helpCenter?index=3", name: "常见问题"},
        {url: "/helpCenter?index=3", name: "人力资源许可证"},
        {url: "/helpCenter?index=3", name: "电子营业执照"}
      ],
    };
  },
  mounted() {

  },
  methods: {
    changeRoute(path) {
      console.log(this.routePath);
      if (
          path == "/headfairmain/talentAssessment" ||
          path == "/headfairmain/baicaiHeadhunting" ||
          path == "/headfairmain/RPO" ||
          path == "/headfairmain/reference"
      ) {
        this.routePath = true;
      } else {
        this.routePath = false;
      }
    },
    toPost() {
      window.open('https://beian.mps.gov.cn/#/query/webSearch')
    },
    toLong() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    },
    aboutOur() {
      this.$router.push({
        path: '/helpCenter',
        query: {index: 3}
      })
    },
    tohelp(item) {
      this.$router.push(item.url)
    },
    userClick() {
      if (Cookies.get('CompanyAuthorization')) {
        this.$router.push('/agreement?2')
      } else {
        this.$router.push('/agreement?1')
      }
    }
  },
  watch: {
    $route(to, from) {
      this.changeRoute(to.path);
    },
  },
};
</script>

<style scoped>
.layout	{
	display: -webkit-flex;
	display: flex;
	justify-content: space-between
}	
	
.footer_box {
  min-height: 200px;
  width: 100%;
  background-color: rgb(48, 48, 48);
  padding: 34px 0 0 0;
  text-align: center;
  box-sizing: border-box;
}

.footer_box_link {
  display: flex;
  justify-content: center;
}

.footer_box_item {
  font-size: 15px;
  font-weight: 400;
  line-height: 21.72px;
  color: rgba(132, 206, 250, 1);
  padding: 0 20px;
  position: relative;
  cursor: pointer;
}

.footer_box_item::after {
  display: block;
  content: '|';
  color: #fff;
  position: absolute;
  top: 0;
  right: 0;
}

.footer_box_item:last-child::after {
  display: none;
}

.footer_box_titl {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
}

.footer_box_li,
.footer_box_bq {
  display: flex;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 24px;
  color: rgba(153, 153, 153, 1);
  text-align: center;
  vertical-align: top;
  justify-content: center;
}

.footer_box_bq a{
	color: #fff;
}

.footer_box_bq img{
	width: 15px;
	height: 16px;
}

.footer_box_li > span {
  padding: 0 10px;
  cursor: pointer;
}
.footer_qr_code{
	
}
.footer_qr_code ul{
	margin-top: 16px;
}
.footer_qr_code ul li{
	float: left;
	margin-right: 20px;
}
.footer_qr_code ul li p{
	color: #fff;
	font-size: 14px;
	padding: 6px 0;
}
</style>
